module.exports = __webpack_public_path__ + "img/about-banner.d8f6560e.jpg";